import { FC } from 'react';
import { Trans } from 'react-i18next';
import { Alert, AlertContent, AlertDescription, AlertIcon } from '@bice_vida/ds-components-alert';
import classNames from 'classnames';

import styles from './DevStageAlert.module.scss';

const STAGE = process.env.STAGE || '';

type DevStageAlertProps = {
  isTokuPage?: boolean;
};

const DevStageAlert: FC<DevStageAlertProps> = ({ isTokuPage = false }) => {
  if (STAGE !== 'dev') return null;

  return (
    <div
      className={classNames(styles['dev_alert'], {
        [styles['dev_alert--margin']]: isTokuPage,
      })}
    >
      <Alert variant="warning">
        <AlertIcon />
        <AlertContent>
          <AlertDescription className={styles['dev_alert__description']}>
            <Trans i18nKey="dev_alert.description" components={{ span: <span /> }} />
          </AlertDescription>
        </AlertContent>
      </Alert>
    </div>
  );
};

export default DevStageAlert;
